// src/api/promoCodesApi.js
import axios from "axios";

const BASE = `${process.env.REACT_APP_SERVER_URL}/api/admin/promo-codes`;

function authHeader(token) {
    return { headers: { Authorization: `Bearer ${token}` } };
}

/** List every promo code with its redemption counts (admin only). */
export async function fetchPromoCodes(token) {
    const { data } = await axios.get(BASE, authHeader(token));
    return data.codes || [];
}

/** Create a code. `trialDays` is the total free period it grants. */
export async function createPromoCode(token, payload) {
    const { data } = await axios.post(BASE, payload, authHeader(token));
    return data.code;
}

/** Update a code's settings. Redemption counts are not editable. */
export async function updatePromoCode(token, id, payload) {
    const { data } = await axios.patch(`${BASE}/${id}`, payload, authHeader(token));
    return data.code;
}

/** Delete a code, or deactivate it if it already has redemptions. */
export async function deletePromoCode(token, id) {
    const { data } = await axios.delete(`${BASE}/${id}`, authHeader(token));
    return data;
}
